const menu = {
  main: {
    contracts: "Hợp đồng"
  },
  userMenu: {
    logout: "Đăng xuất"
  },
};

export default menu;